import React, { useState } from "react";
import yesIcon from "../../images/YES.svg";
import noIcon from "../../images/NO.svg";
import { Grid, Typography } from "@material-ui/core";
import withStyles from "@material-ui/core/styles/withStyles";
import styles from "./styles";
import { isEmpty, range } from "lodash";
import Draggable from "react-draggable";
import "animate.css/animate.css";


const GDPDroppable = (props) => {
  const {
    aref,
    title,
    inAnswer,
    getAnswers,
    currentAnswer,
    // ifAnswer,
    classes,
    onDragEnd,
    onDragUpdate,
    dragStarted,
    setDragStarted,
    marginTop,
    // showAnimation
  } = props;

  let index = getAnswers(title).length;

  const onDragStart = () => setDragStarted(true);

  const renderRemainingOptions = () => {
    if (inAnswer)
      return range(4 - index).map(() => (
        <Grid className={classes.droppableAnswer} />
      ));
    return range(4 - index).map(() => (
      <Grid className={classes.droppableCircle} />
    ));
  };

  const renderDraggableAnswer = () => {
    // console.log("index", currentAnswer?.answer, title);
    if (currentAnswer?.answer === title) {
      if (!dragStarted) index += 1;
      return (
        <div style={{ position: "relative" }}>
          <Draggable
            onDrag={onDragUpdate}
            onStart={onDragStart}
            onStop={(e) => onDragEnd(e, () => setDragStarted(false))}
            position={{ x: 0, y: 0 }}
          >
            {!dragStarted ? (
              <Grid
                className={classes.droppableAnswer}
                style={{ cursor: "pointer" }}
              >
                <img src={currentAnswer.imgSrc} width="100%" />
              </Grid>
            ) : (
              <Grid
                container
                alignItems="center"
                className={classes.innerDroppableElement}
              >
                <img
                  id="answer-icon"
                  src={currentAnswer.imgSrc}
                  className={classes.questionImg}
                />
                <Grid>
                  <Typography className={classes.serviceTitle}>
                    {currentAnswer.title}
                  </Typography>
                  <Typography className={classes.serviceDesc}>
                    {currentAnswer.desc}
                  </Typography>
                </Grid>
              </Grid>
            )}
          </Draggable>
        </div>
      );
    }
  };

  const renderAnswers = () => {
    let answers = getAnswers(title)
    const lastAnswer = answers.splice(-1)
    console.log("answers", answers)
    console.log("lastAnswer", lastAnswer)
    return (
      <>
        {answers.map((answer) => (
          <Grid className={classes.droppableAnswer}>
            {!inAnswer && <img src={answer.icon} width="100%" />}
          </Grid>
        ))}
        {lastAnswer[0] && <Grid className={classes.droppableAnswer}>
          {!inAnswer &&
            <img
              src={lastAnswer[0].icon}
              // className={`${showAnimation && "animate__animated animate__bounceIn"}`}
              width="100%"
            />}
        </Grid>}
      </>
    );
  };

  return (
    <Grid className={classes.draggableDrop} ref={aref} style={{ marginTop: marginTop, position: "relative" }}>
      { title === "Private Good" &&
        <p className={classes.rivalText}>Rival</p>
      }
      { title === "Club Good" &&
        <p className={classes.nonRivalText}>Non-rival</p>
      }
      <Grid
        container
        alignItems="center"
        className={classes.answerTitleContainer}
      >
        {console.log("inAnswer", inAnswer)}
        {/* <img
          src={title === "yes" ? yesIcon : noIcon}
          className={classes.answerTitleIcon}
        />
        <Typography className={classes.answerTitleText}>
          {`${
            title === "yes"
              ? "SUNK COST"
              : "NOT A SUNK COST"
          }`}
        </Typography> */}
        <Typography className={classes.answerTitleText}>
          {title}
        </Typography>
      </Grid>
      <Grid
        container
        justify="space-evenly"
        className={classes.answerDescContainer}
        style={{ [inAnswer && "backgroundColor"]: "#1db2d7" }}
      >
        {renderAnswers()}
        {renderDraggableAnswer()}
        {renderRemainingOptions()}
      </Grid>
    </Grid>
  );
};

export default withStyles(styles)(GDPDroppable);
